/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import Tabs from '@digital-hig/mui/dist/Tabs';
// eslint-disable-next-line import/no-extraneous-dependencies
import Tab from '@mui/material/Tab';

const LeftNav = ({
  navItems, isSticky, leftNavRef,
  curSelectedItem,
}) => {
  const [currentTabValue, setCurrentTabValue] = useState(curSelectedItem);

  const handleLeftNavChange = (e) => {
    const filterAvailableTabs = navItems.filter((tab) => tab.render);
    const getSelectedTab = filterAvailableTabs.findIndex((tab) => tab.menuItemName === e.target.id);
    setCurrentTabValue(getSelectedTab);

    const ele = document.querySelector(`[data-id="${e.target.id}"]`);
    window.scrollTo({ behavior: 'smooth', top: ele?.offsetTop - 110 });
  };

  useEffect(() => {
    if (!curSelectedItem) {
      setCurrentTabValue(0);
    } else {
      setCurrentTabValue(curSelectedItem);
    }
  }, [curSelectedItem]);

  return (
    <RootElement ref={leftNavRef} data-testid="left-nav">
      <Grid key="menucontainer" className={`${isSticky ? 'sticky' : ''}`}>
        <Tabs value={currentTabValue} orientation="vertical" onChange={handleLeftNavChange} styleVariant="quiet" sx={{ display: { xs: 'none', lg: 'block' } }}>
          {navItems.map((tab) => (tab.render && <Tab id={tab.menuItemName} label={tab.menuItemName} />))}
        </Tabs>
      </Grid>
      <Grid key="m-menucontainer" className={`${isSticky ? 'm-sticky' : 'm-tab-container'}`}>
        <Tabs extendedUnderline value={currentTabValue} onChange={handleLeftNavChange} styleVariant="quiet" sx={{ display: { xs: 'block', lg: 'none' } }}>
          {navItems.map((tab) => (tab.render && <Tab id={tab.menuItemName} label={tab.menuItemName} />))}
        </Tabs>
      </Grid>
    </RootElement>
  );
};

const RootElement = styled.div`
  height: calc(100% - 1.5rem);
  .m-sticky {
    position: fixed;
    background: #fff;
    width: 100%;
    top: 82px;
    z-index: 999;
    margin-left: -16px;
    
    > div {
      height: 0;
      padding-left: 16px;
    }
  }
  .m-tab-container{
    > div {
      height: 0;
    }
  }
  .sticky {
    position: sticky;
    margin-top: 20px;
    top: 100px;
  }
  @media screen and (max-width: 560px) {
    .m-sticky {
      top: 121px;
    }
  }
`;

LeftNav.propTypes = {
  navItems: PropTypes.arrayOf().isRequired,
  isSticky: PropTypes.bool,
  thinHeaderRef: PropTypes.shape({
    current: PropTypes.shape({
      childNodes: PropTypes.arrayOf(),
    }),
  }).isRequired,
  curSelectedItem: PropTypes.string.isRequired,
  leftNavRef: PropTypes.shape({}).isRequired,
  // isThinHeaderVisible: PropTypes.bool.isRequired,
};

LeftNav.defaultProps = {
  isSticky: false,
};

export default LeftNav;
